<template>
  <div class="modal fade"
       id="modal-create-category"
       tabindex="-1"
       role="dialog"
       data-bs-backdrop="static"
       data-bs-keyboard="false">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title">{{ category ? 'Modifier la Catégorie' : 'Ajouter une Catégorie' }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
        </div>
        <div class="modal-body">
          <ValidationObserver ref="observer" v-slot="{ invalid }">
            <form @submit.prevent="submitForm">

              <div class="form-row">
                <div class="form-group col-md-6 mb-0">
                  <ValidationProvider
                      name="Code"
                      rules="required|min:2|max:5"
                      v-slot="{ errors }"
                      :custom-messages="{
    min: 'Le code doit contenir au moins 2 caractères.',
    max: 'Le code doit contenir au plus 5 caractères.'
  }"
                  >
                    <label class="form-label">Code <span class="text-danger">*</span></label>
                    <input
                        v-model="payload.code"
                        type="text"
                        :disabled="isEdit"
                        @input="payload.code = (payload.code || '').toUpperCase()"
                        class="form-control"
                        placeholder="Entrer code..."
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </div>

                <div class="form-group col-md-6 mb-0">
                  <ValidationProvider name="Label" rules="required" v-slot="{ errors }">
                    <label class="form-label">Nom de la catégorie <span class="text-danger">*</span></label>
                    <input
                        v-model="payload.label"
                        @input="payload.label = (payload.label || '').toUpperCase()"
                        type="text"
                        class="form-control"
                        placeholder="Ex: Informatique, Bâtiment..."
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </div>
              </div>

              <!-- Sélection du parent -->
              <div class="form-row mt-3">
                <div class="form-group col-12 mb-0">
                  <ValidationProvider name="Catégorie parente" v-slot="{ errors }">
                    <label class="form-label">Catégorie parente</label>

                    <!-- Utilise les options filtrées pour exclure self + descendants -->
                    <GenericSelect
                        v-model="payload.parentId"
                        :options="filteredParentOptions"
                        label-key="label"
                        track-key="id"
                        placeholder="Aucune (catégorie racine)"
                        :clearable="true"
                    />

                    <small class="text-muted">Laissez vide pour créer une catégorie racine.</small><br>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </div>
              </div>


              <div class="text-end mt-4">
                <button type="button" class="btn btn-gray me-2" data-bs-dismiss="modal">Annuler</button>
                <button type="submit" class="btn btn-success" :disabled="invalid">
                  <i class="fe fe-check"></i>  {{ category ? 'Modifier' : 'Créer' }}
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {confirmAction, showValidationErrors} from "../../helpers/helpers";
  import GenericSelect from "../GenericSelect.vue";

  export default {
    name: "ModalCreateCategory",
    components: {GenericSelect},
    props: {
      category: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        isEdit: !!this.category,
        payload: {
          code: '',
          label: '',
          parentId: null
        },
        parentOptions: [],
        disabledParentIds: new Set(),
      };
    },
    watch: {
      category: {
        immediate: true,
        handler(newVal) {
          if (newVal) {
            this.payload = {
              code: newVal.code || '',
              label: newVal.label || '',
              parentId: newVal.parentId || (newVal.parent && newVal.parent.id) || null,
            };
          } else {
            this.payload = {
              code: '',
              label: '',
              parentId: null
            };
          }
        },
      },
    },
    mounted() {
      $('#modal-create-category').on('hidden.bs.modal', () => {
        this.resetForm();
      });
      $('#modal-create-category').on('show.bs.modal', async () => {
        await this.loadParentOptions();
      });
    },
    beforeDestroy() {
      $("#modal-create-category").off("hidden.bs.modal");
    },
    computed: {
      isEdit() {
        return !!this.category;
      },
      filteredParentOptions() {
        return this.parentOptions.filter(o => !this.disabledParentIds.has(o.value));
      },
    },
    methods: {
      async loadParentOptions() {
        try {
          this.$loading(true);
          // 1) Charger toutes les catégories (afin de pouvoir choisir n'importe laquelle comme parent)
          const { data } = await this.$http.get('registry/categories/roots');
          this.parentOptions = (data || [])

          // 2) Exclure soi + descendants en édition
          this.disabledParentIds = new Set();
          if (this.category && this.category.id) {
            this.disabledParentIds.add(this.category.id);
            try {
              const { data: subtree } = await this.$http.get(`registry/categories/${this.category.id}/subtree`);
              (subtree || []).forEach(n => this.disabledParentIds.add(n.id));
            } catch (e) {
              console.warn("Sous-arbre indisponible; on désactive uniquement la catégorie courante.", e);
            }
          }
        } catch (e) {
          console.error("Erreur chargement catégories parentes :", e);
          this.$loading(false);
        } finally {
          this.$loading(false);
        }
      },
      resetForm() {
        this.payload = { code: '', label: '' };
        if (this.$refs.observer) {
          this.$refs.observer.reset();
        }
      },
      async  submitForm() {

        const isValid = await this.$refs.observer.validate();
        if (!isValid) return;

        // Vérifie unicité en mode création
        if (!this.category) {
          const exists = await this.$http.get(`/registry/categories/exists/${this.payload.code}`);
          if (exists.data) {
            swal('Erreur', 'Ce code existe déjà, veuillez en choisir un autre.', 'error');
            return;
          }
        }

        const confirmed = await confirmAction('create');
        if (!confirmed) return;

        this.$loading(true);

        const request = this.category
            ? this.$http.put(`/registry/categories/${this.category.code}`, this.payload)
            : this.$http.post("/registry/categories", this.payload);

        this.$loading(true);
        request
            .then(() => {
              if (this.$refs.observer) {
                this.$refs.observer.reset();
              }
              setTimeout(() => {
                swal(
                    'Succès',
                    this.category ? 'Catégorie modifiée avec succès.' : 'Catégorie créée avec succès.',
                    'success'
                );
              }, 300);
              this.$emit('refresh');
              $('#modal-create-category').modal('hide');
              this.resetForm();
            })
            .catch((err) => {

              console.error(err);
              setTimeout(() => showValidationErrors(err), 300);
            })
            .finally(() => this.$loading(false));
      },
    },
    created() {
      this.loadParentOptions();
    }
  };
</script>
